import { all, takeLatest, put } from 'redux-saga/effects';
import { requestStatisticsCalendar } from './api';
import { statisticsCalendarSuccess} from './actions';

import {
    STATISTICS_CALENDAR_ROUTE
} from './constants';

/**
 *
 * @param action
 * @returns {IterableIterator<PutEffect<*>>}
 */
function* getCalendarStatistics(action) {
  const cstatistic = yield requestStatisticsCalendar(action.calendarID);
  
  if (cstatistic){
    yield put( statisticsCalendarSuccess (cstatistic) );
  }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchCalendarStatistics(){
  yield  takeLatest(STATISTICS_CALENDAR_ROUTE, getCalendarStatistics);
}

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* calendarStatisticsSaga(){
  yield all([
    watchCalendarStatistics()
  ]);
}

export default calendarStatisticsSaga;